import { render, staticRenderFns } from "./WorkOrder.vue?vue&type=template&id=12851a3f&"
import script from "./WorkOrder.vue?vue&type=script&lang=js&"
export * from "./WorkOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports